import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import About from "./components/About/";
import Footer from "./components/Footer/";
import Header from "./components/Header/";
import Home from "./page/Home";

function App() {
  return (
    <>
      <ToastContainer
        autoClose={3000}
        closeButton={false}
        newestOnTop
        position="top-right"
        theme="colored"
      />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
